import React from 'react'
import { Box, List, listItemButtonClasses, Theme } from '@mui/joy'
import { defaultAdminMenu, defaultBottomMenu, defaultTopMenu } from './MenuData'
import { IMenuItem } from 'interfaces/IMenu'
import RenderMenu from './RenderMenu'
import { useModuleMenu } from 'core/hooks/useModuleMenu'
import { useProfileContext } from 'contexts/ProfileContext'
import { useLocation } from 'react-router-dom';

const sx = {
    minHeight: 0,
    overflow: 'hidden auto',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    [`& .${listItemButtonClasses.root}`]: {
        gap: 1.5,
    },
}

const Menu = () => {
    const { moduleMenu } = useModuleMenu();
    const { profile } = useProfileContext();

    const location = useLocation();

    return (
        <Box sx={sx}>
        {/* <Box
            sx={{
                ...sx,
                width: '220px',
                transition: 'width 0.3s ease',
            }}
        > */}
            <List
                size="sm"
                sx={{
                    gap: 1,
                    '--List-nestedInsetStart':'30px',
                    '--ListItem-radius': (theme: Theme) => theme.vars.radius.sm,
                }}
            >
                {defaultTopMenu.map((m: IMenuItem) => (<RenderMenu menu={m} key={m.id} />))}
                {moduleMenu.map((m: IMenuItem) => (<RenderMenu menu={m} key={m.id} />))}
            </List>

            <List
                size="sm"
                sx={{
                    mt: 'auto',
                    flexGrow: 0,
                    '--ListItem-radius': (theme) => theme.vars.radius.sm,
                    '--List-gap': '8px',
                    mb: 2,
                }}
            >
                {defaultBottomMenu.map((m: IMenuItem) => (<RenderMenu menu={m} key={m.id}/>))}

                {profile?.role === "super-admin" ?
                    defaultAdminMenu.map((m: IMenuItem) => (<RenderMenu menu={m} key={m.id}/>)) :
                    null
                }
            </List>
        </Box>
    )
}

export default Menu